const asArray = (value) => Array.isArray(value) ? value : [];
const positiveId = (value) => Number.isInteger(Number(value)) && Number(value) > 0;

export const getWaitingStage = (row = {}) => {
  if (!positiveId(row.eval_id) || !positiveId(row.frequency_id) || !positiveId(row.importancy_id)) return "assessment";
  if (Number(row.eval_status) >= 20) return null;
  if (Number(row.requires_improve) !== 1 || Number(row.improve_status) >= 20) return "approval";
  if (String(row.improve_plan || "").trim() || Number(row.improve_status) >= 10) return "implementation";
  return "planning";
};

export const buildWorkflowSummary = (pendingRows, savedRows) => {
  const rowsByCause = new Map();
  asArray(pendingRows).forEach((row) => {
    if (row && !row.__lineGroup && positiveId(row.register_cause_id)) {
      rowsByCause.set(Number(row.register_cause_id), row);
    }
  });
  // Line and individual views refer to the same hazard. Count its latest evaluation only.
  asArray(savedRows).forEach((row) => {
    if (!row || row.__lineGroup || !positiveId(row.register_cause_id)) return;
    const key = Number(row.register_cause_id);
    const previous = rowsByCause.get(key);
    if (!previous || Number(row.eval_id || 0) >= Number(previous.eval_id || 0)) rowsByCause.set(key, row);
  });
  const counts = { assessment: 0, planning: 0, implementation: 0, approval: 0, evaluated: 0, total: rowsByCause.size };
  rowsByCause.forEach((row) => {
    const stage = getWaitingStage(row);
    if (stage) counts[stage] += 1;
    if (stage !== "assessment") counts.evaluated += 1;
  });
  return { ...counts, completionRate: counts.total ? Math.round(counts.evaluated / counts.total * 100) : 0 };
};
